import { collectNestedFormErrors, emptyStringToUndefinedValueAs } from "@/utils/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, UseFormProps, UseFormReturn } from "react-hook-form";
import toast from "react-hot-toast";
import * as z from "zod";

// Simple helper function to make the most common type of form a little easier
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useFormForSchema<T extends z.ZodSchema<any, any>>(
  schema: T,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props?: UseFormProps<z.TypeOf<T>, any>,
): UseFormReturn<z.TypeOf<T>> {
  const form = useForm<z.input<T>, unknown, z.output<T>>({
    resolver: zodResolver(schema),
    ...props,
  });

  const register: typeof form.register = (name, options) => {
    if (options?.setValueAs || options?.valueAsDate || options?.valueAsNumber) {
      return form.register(name, options);
    }

    return form.register(name, {
      ...options,
      setValueAs: emptyStringToUndefinedValueAs,
    });
  };

  const handleSubmit: typeof form.handleSubmit = (onValid, onInvalid) =>
    form.handleSubmit(
      onValid,
      onInvalid ??
        ((errors) =>
          toast.error(`Invalid Submission: ${collectNestedFormErrors(errors).join(", ")}`)),
    );

  return {
    ...form,
    register,
    handleSubmit,
  } as UseFormReturn<z.TypeOf<T>>;
}
